import { authActions } from '@/actions/auth';
import { App } from '@/App';
import { config } from '@/config';
import { parseQueryString, clearCache } from '@/util';
import ReactDOM from 'react-dom/client';
import { initLanguage } from './language';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';
import meta from '@/meta.json';
import { axios, publicAxios } from '@/axios';

publicAxios
  .get('/meta.json', {
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })
  .then((response) => {
    const { version } = response.data;
    if (parseFloat(version) !== parseFloat(meta.version as unknown as string)) {
      //eslint-disable-next-line
      clearCache();
    }
  })
  .catch(console.error);

const start = async (auth: any) => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <App authData={auth} />
  );
};

initLanguage();

const queries = parseQueryString(document.location.search) as {
  [key: string]: string;
};

let token;

if (queries['JWT']) {
  token = queries['JWT'];
  localStorage.setItem('token', token);
  delete queries['JWT'];
  token = queries['JWT'];
} else {
  //important during migration to cookie based jwt, keep for 1 month
  token = localStorage.getItem('token');
  localStorage.removeItem('token');
}

if (queries['koffer']) {
  localStorage.setItem('koffer', 'true');
}

if (queries['invite']) {
  localStorage.setItem('invite', queries['invite']);
  delete queries['invite'];
}

if (queries['access']) {
  localStorage.setItem('access', queries['access']);
  publicAxios.defaults.headers.common['Authorization2'] =
    'Bearer ' + queries['access'];
  delete queries['access'];
}

if (queries['skipconsent'] === 'true') {
  localStorage.setItem('skipconsent', 'true');
}

if (queries['skipconsent'] === 'false') {
  localStorage.removeItem('skipconsent');
}

let path =
  window.location.protocol +
  '//' +
  window.location.host +
  window.location.pathname;
if (Object.values(queries).length > 0) {
  path += '?';
  for (const key of Object.keys(queries)) {
    path += key + '=' + queries[key] + '&';
  }
  path = path.slice(0, -1);
}
window.history.replaceState('', '', path);

async function maybeStartMsw() {
  if (!import.meta.env.DEV) return; // compile-time constant
  if (!config.enableMsw) return; // optional runtime flag

  const { worker } = await import('./mocks/worker');
  await worker().start({ onUnhandledRequest: 'warn' });
}

maybeStartMsw();

if (token) {
  try {
    const lastLock = localStorage.getItem('lessonlock');
    if (lastLock)
      axios.delete(config.backend + '/lessonlock/' + lastLock, {
        skipAuthRedirect: true,
      });
    localStorage.removeItem('lessonlock');
  } catch (e) {
    /*just a qol thing */
  }
}

store
  .dispatch(authActions.loginToken(token))
  .then(async (auth: any) => {
    start(auth);
  })
  .catch(() => {
    start(null);
  });
